<template>
  <base-data-table
    :items="events"
    title="イベント時系列"
    header-icon="mdi-timeline-clock-outline"
    scrollable
    scroll-height="260px"
    :column-widths="['160px', '210px', '', '170px']"
  >
    <template #header-cells>
      <th>発生日時</th>
      <th>種類</th>
      <th>内容</th>
      <th />
    </template>
    <template #cells="{ row: event }">
      <td>{{ event.occurredAt }}</td>
      <td>{{ event.type }}</td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ event.content }}
        </div>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          :prepend-icon="actionIcon(event)"
          @click="$emit('open-detail', event)"
        >
          {{ actionLabel(event) }}
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

// イベント種別（sourceType）ごとの、各個別テーブルで表示しているアクションボタンの文言と対応させる。
const ACTION_LABELS = {
  alert: "詳細を開く",
  frequent_support: "詳細を開く",
  municipal_cooperation: "詳細を開く",
  risk_assessment: "相談カルテを開く",
  epds: "閲覧する",
  consultation_service: "相談カルテを開く"
};

// 「相談カルテを開く」ボタンは、個別テーブル（RiskAssessmentHistoryTable / ConsultationServiceHistoryTable）
// と同じくリンクアイコンを付ける。それ以外（詳細を開く/閲覧する）はアイコン無し。
const ACTION_ICONS = {
  risk_assessment: "mdi-open-in-new",
  consultation_service: "mdi-open-in-new"
};

export default {
  name: "FaceSheetEventTimelineTable",
  components: {
    BaseDataTable
  },
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  emits: ["add-event", "open-detail"],
  methods: {
    actionLabel(event) {
      return ACTION_LABELS[event.sourceType] || "詳細を開く";
    },
    actionIcon(event) {
      return ACTION_ICONS[event.sourceType];
    }
  }
};
</script>
